import { render, staticRenderFns } from "./ExtraProductsItemAvailable.vue?vue&type=template&id=79e174d2&"
import script from "./ExtraProductsItemAvailable.vue?vue&type=script&lang=js&"
export * from "./ExtraProductsItemAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports